import { useQuery } from '@tanstack/react-query';
import { fetchScenarioGalleryFromApi } from '@/services/scenarioGalleryService';
import type { ScenarioGalleryItem } from '@/types/scenarioGallery';

export const scenarioGalleryKeys = {
	all: ['scenarioGallery'] as const,
	list: () => [...scenarioGalleryKeys.all, 'list'] as const,
};

/**
 * 공개 시나리오 목록
 */
export function useScenarioGalleryList() {
	return useQuery<ScenarioGalleryItem[]>({
		queryKey: scenarioGalleryKeys.list(),
		queryFn: () => fetchScenarioGalleryFromApi(),
		staleTime: 5 * 60 * 1000,
	});
}
